import axios from 'axios'
import { AuthParameters } from './AuthServices';
import { API_BASE_URL } from '../config';

const RegisterServices = async (formData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}user-register/`, formData);

        if (response.status === 400) {
            return "El email de este usuario ya esta registraodo"
        } else {
            return response.data
        }
    } catch (error) {
        throw Error(error)
    }
}

export const registerParameters = async (formData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}user-register/`, formData);

        if (response.status === 400) {
            return "El email de este usuario ya esta registraodo"
        } else {
            await AuthParameters(formData['email']);
        }
    } catch (error) {
        throw Error(error)
    }
}

export default RegisterServices
